import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faGift } from "@fortawesome/pro-regular-svg-icons/faGift";
import { faRocketLaunch } from "@fortawesome/pro-regular-svg-icons/faRocketLaunch";
import { faMedal } from "@fortawesome/pro-regular-svg-icons/faMedal";
import { faMapPin } from "@fortawesome/pro-regular-svg-icons/faMapPin";
import { faRoute } from "@fortawesome/pro-regular-svg-icons/faRoute";
import { faBolt } from "@fortawesome/pro-regular-svg-icons/faBolt";
import { faFire } from "@fortawesome/pro-regular-svg-icons/faFire";
import { faStar } from "@fortawesome/pro-regular-svg-icons/faStar";
import { faCrown } from "@fortawesome/pro-regular-svg-icons/faCrown";
import { faHourglass } from "@fortawesome/pro-regular-svg-icons/faHourglass";
import { faGauge } from "@fortawesome/pro-regular-svg-icons/faGauge";
import { faSeedling } from "@fortawesome/pro-regular-svg-icons/faSeedling";
import { faTrophy } from "@fortawesome/pro-regular-svg-icons/faTrophy";
import { faClock } from "@fortawesome/pro-regular-svg-icons/faClock";
import { faStopwatch } from "@fortawesome/pro-regular-svg-icons/faStopwatch";

import { Milestone, IconSetType } from "./types";

// ── SVG/Arc Dimensions ───────────────────────────────────────────────────────
export const ARC_CENTER = { x: 180, y: 180 };
export const ARC_R = 167;
export const STROKE = 24;
export const ARC_LEN = Math.PI * ARC_R; // ~524.67
export const ARC_PATH = `M ${ARC_CENTER.x - ARC_R} ${ARC_CENTER.y} A ${ARC_R} ${ARC_R} 0 0 1 ${ARC_CENTER.x + ARC_R} ${ARC_CENTER.y}`;

// ── Icon Definitions ──────────────────────────────────────────────────────────
export const FA_ICONS: Record<string, IconProp> = {
  gift: faGift,
  rocket: faRocketLaunch,
  medal: faMedal,
  mapPin: faMapPin,
  route: faRoute,
  bolt: faBolt,
  fire: faFire,
  star: faStar,
  crown: faCrown,
  hourglass: faHourglass,
  gauge: faGauge,
  seedling: faSeedling,
  trophy: faTrophy,
  clock: faClock,
  stopwatch: faStopwatch,
};

export const ICON_SETS = {
  Original: ["gift", "rocket", "medal"],
  Journey: ["mapPin", "route", "medal"],
  Energy: ["bolt", "fire", "medal"],
  Podium: ["star", "crown", "medal"],
  "Time/Speed": ["hourglass", "gauge", "medal"],
  Growth: ["seedling", "trophy", "medal"],
};

export function getMilestones(set: IconSetType): Milestone[] {
  const ic = ICON_SETS[set];
  return [
    { at: 6, icon: ic[0], reward: 1 },
    { at: 7, icon: ic[1], reward: 2 },
    { at: 8, icon: ic[2], reward: 3, isBadge: true },
  ];
}

export function getPos(at: number, isFlat: boolean) {
  if (isFlat) {
    return {
      x: 20 + at * 57.5,
      y: 40,
    };
  }
  const angle = 180 - (at / 8) * 180;
  const r = (angle * Math.PI) / 180;
  return {
    x: ARC_CENTER.x + ARC_R * Math.cos(r),
    y: ARC_CENTER.y - ARC_R * Math.sin(r),
  };
}
